var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06684 25.9828H11.7668C11.7671 25.9828 24 27.0087 24 13.2091C24 -0.0555201 12.8291 -0.00848407 10.67 0.000556837C10.6195 0.0007932 10.5739 0.000970473 10.5335 0.000970473H3.0666V11.5748H0V14.4097H3.06684V25.9828ZM8 4C8 4 9.5011 4 11.3756 4C13.25 4 18.5 4 19 12.3036C19.5 20.6073 13.5 22 11.5 22C11.4875 22 8 21.9999 8 21.9999V13.3851H13.3106V10.6153H8V4Z",
    fill: "#C2A633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoge);
export default __webpack_public_path__ + "static/media/doge.2377432aa75f5c1a100be91a213120d8.svg";
export { ForwardRef as ReactComponent };